module.exports = "<div >\r\n    <div fxFill fxLayout=\"row\" fxLayoutAlign=\"center center\">\r\n        <label style=\"color:red;font-size:50px;\">תקלה</label>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error-page/error-page.component.html
// module id = ./src/app/components/error-page/error-page.component.html
// module chunks = main